import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import Pagination from '@/components/Pagination.vue'
import Keys from '@/constant/key'
import { getExpiredListApi, updateExpiredStatusApi } from '@/apis/coupon'
import { getCurrentInstance, reactive, ref } from 'vue'
import { useStore } from '@/store'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpiredList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const filters = reactive({
    card: '', // 券码
    coupon_name: '', // 券名
    brand_name: '', // 品牌名
    amount: '', // 面值
    status: '', // 状态
    type: '', // 类型
    page: 1, // 当前页码
    page_size: 10, // 每页显示条数
})

// 获取列表数据
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getExpiredListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
getList()

// 打开上传更新弹窗
const dialogVisibleNew = ref(false)
const openDialogNew = () => {
    dialogVisibleNew.value = true
}
const uploadRef = ref()
// 关闭上传更新弹框
const dialogBeforeCloseNew = () => {
    uploadRef.value!.clearFiles() // 清除数据
    dialogVisibleNew.value = false
    getList()
}
const onUploadSuccess= async (res) => {
    const { code, data, msg } = res
    if(code == 200) {
        proxy.$message({ type: 'success', message: msg })
        dialogBeforeCloseNew()
        getList()
    } else {
        uploadRef.value!.clearFiles() // 清除数据
        return proxy.$message({ type: 'error', message: msg })
    }
}
//确定上传
const dialogSubmit= () => {
    proxy.$refs.uploadRef.submit()
}

const updateStatus = (id, type) => {
    proxy.$confirm(`确定要标记为${ type === 1 ? '已换券' : '已作废' }吗？`, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true
    }).then(async () => {
        const { code, msg } = await updateExpiredStatusApi(id, type) as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        proxy.$message({ type: 'success', message: '操作成功' })
        getList()
    }).catch(() => {
        proxy.$message({ type: 'info', message: '取消标记' })
    })
}
const onExport = () => {
    window.open(`${Keys.baseUrl}/coupon/couponsExpiredExport?${joinParams({...filters, user_id:store.state.user.userInfo.id })}`);
}
const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_decimal = _resolveDirective("decimal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.card,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.card) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券码",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.coupon_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.coupon_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.brand_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "品牌",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _withDirectives(_createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.amount,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.amount) = $event)),
        modelModifiers: { trim: true },
        placeholder: "面值",
        clearable: ""
      }, null, 8, ["modelValue"]), [
        [_directive_decimal]
      ]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.status) = $event)),
        placeholder: "状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待处理",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已换券",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "已作废",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.type,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.type) = $event)),
        placeholder: "类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "采购",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "自制",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openDialogNew
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("批量上传更新状态")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "card",
          label: "券码"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值"
        }),
        _createVNode(_component_el_table_column, {
          prop: "source",
          label: "类型"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.type == 1 ? '采购' : '自制'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "validity_end_time",
          label: "过期时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_name",
          label: "状态"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "200",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: scope.row.status != 0,
                title: scope.row.status == 1 ? '已换券' : scope.row.status == 2 ? '已作废' : '',
                onClick: ($event: any) => (updateStatus(scope.row.id, 1))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("标记已换券")
                ])),
                _: 2
              }, 1032, ["disabled", "title", "onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: scope.row.status != 0,
                title: scope.row.status == 1 ? '已换券' : scope.row.status == 2 ? '已作废' : '',
                onClick: ($event: any) => (updateStatus(scope.row.id, 2))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("标记已作废")
                ])),
                _: 2
              }, 1032, ["disabled", "title", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传更新状态",
      modelValue: dialogVisibleNew.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisibleNew).value = $event)),
      "before-close": dialogBeforeCloseNew
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeCloseNew }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: `/api/coupon/couponsExpiredSaveStatusAll`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ml20 color-danger" }, "注：更新状态描述\"已作废\" \"已换券\"，注意规范", -1))
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})